import { AxiosResponse } from 'axios'

import { Snippet } from '../models/Snippet.model'
import authAxios from './auth.axios'

const baseUrl = process.env.REACT_APP_API

// Creates a new snippet for a user
export const createSnippet = async (data: { abbreviation: string; content: string }, userId: string): Promise<Snippet> => {
    try {
        const url = `${baseUrl}/snippets?userId=${userId}`
        const response: AxiosResponse = await authAxios.post(url, data)
        return response.data
    } catch (error: any) {
        throw error.response?.data || {}
    }
}

// Updates an existing snippet
export const updateSnippet = async (id: string, updates: { abbreviation: string; content: string }): Promise<void> => {
    try {
        const url = `${baseUrl}/snippets/${id}`
        const response: AxiosResponse = await authAxios.put(url, updates)
        return response.data
    } catch (error: any) {
        throw error.response?.data || {}
    }
}

// Deletes a snippet by ID
export const deleteSnippet = async (id: string): Promise<void> => {
    try {
        const url = `${baseUrl}/snippets/${id}`
        const response: AxiosResponse = await authAxios.delete(url)
        return response.data
    } catch (error: any) {
        throw error.response?.data || {}
    }
}

// Gets all snippets for a user
export const getSnippets = async (userId: string): Promise<Snippet[]> => {
    try {
        const url = `${baseUrl}/snippets?userId=${userId}`
        const response: AxiosResponse = await authAxios.get(url)
        return response?.data || []
    } catch (error: any) {
        throw error.response?.data || {}
    }
}

// Gets a single snippet by ID
export const getSnippet = async (id: string): Promise<Snippet> => {
    try {
        const url = `${baseUrl}/snippets/${id}`
        const response: AxiosResponse = await authAxios.get(url)
        return response.data
    } catch (error: any) {
        throw error.response?.data || {}
    }
}
